<template>
  <div>
    <div class="container">
              <div class="box">
                  <div class="header">
                  </div>
                  <div class="animation">
                      <div class="one spin-one"></div>
                      <div class="two spin-two"></div>
                      <div class="three spin-one"></div>
                  </div>
              <h1>SISTEMA EN MANTENIMIENTO</h1>
              <p>ESTAMOS TRABAJANDO PARA LIBERAR NUEVAS FUNCIONES, REGRESA EN UN PAR DE HORAS PARA VER EL NUEVO SITIO.</p>
      </div>
      </div nd="box">
  </div>
</template>

<script>
export default {
  name:"MaintenanceMode"
}
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700');
    body {
        font-family: 'Open Sans', sans-serif;
        color:#666666;
        background:#fff;
        margin:0;
    }

    .container {
        margin:0  auto;
        width: 100%;
        height: 100vh;
        text-align: center;
        position:relative;
        display:flex;
        align-items:middle;
    }

    .box {
        position:relative;
        width:100vw;
        background: #f2f2f2;
        margin: 0 auto;
        padding:64px;
        box-shadow: 6px 18px 18px rgba(0, 0, 0, 0.08), -6px 18px 18px rgba(0, 0, 0, 0.08);
        box-sizing: border-box;
        overflow:hidden;

    }

    .header{
        background:#dfdfdf;
        position:absolute;
        width:100%;
        height:60px;
        top:0;
        left:0;
    }

    .animation{
        margin-top:120px;
        display:inline-block;
        margin-bottom:32px;
    }

    h1{
        font-size:32px;
        font-weight:400;
        margin:0 auto 24px;
    }

    p{
        font-size:20px;
        font-weight:100;
        margin:0 auto;
        text-align:center;
        max-width:500px;
    }

    .one, .two, .three {
        display:block;
        float:left;
    }

    .one {
        background: url('../../../assets/verde.png');
        width:100px;
        height:100px;
        background-size:100% 100%;
        background-repeat:no-repeat;
        margin-top:-50px;
        margin-right:-25px;
    }

    .two {
        background: url('../../../assets/azul.png');
        width:110px;
        height:110px;
        background-size:100% 100%;
        background-repeat:no-repeat;
    }

    .three {
        background: url('../../../assets/verde.png');
        width:100px;
        height:100px;
        background-size:100% 100%;
        background-repeat:no-repeat;
        margin-top:-50px;
        margin-left:-25px;
    }

    @keyframes spin-one {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(-359deg) ;
            transform: rotate(-359deg) ;
        }
    }

    .spin-one {
        -webkit-animation: spin-one 2.5s infinite linear;
        animation: spin-one 2.5s infinite linear;
    }

    @keyframes spin-two {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(-359deg);
            transform: rotate(359deg);
        }
    }

    .spin-two {
        -webkit-animation: spin-two 3s infinite linear;
        animation: spin-two 3s infinite linear;
    }

    @media only screen and (max-width: 768px){

        .box{
            padding:32px;
            width:100vw;
        }

        h1{
            font-size:24px;
        }

        .animation{
        margin-top:140px;
        margin-bottom:16px;
        }

        p{
            font-size:16px;
            max-width:300px;
            text-align:justify;
            padding-bottom:32px;
        }


        .one {
            width:80px;
            height:80px;
        }

        .two {
            width:90px;
            height:90px;
        }

        .three {
            width:80px;
            height:80px;
        }

    }
    @media only screen and (max-width: 360px){
        .box{
            width:100vw;
            padding:16px;
        }

        h1{
            font-size:18px;
        }

        .animation{
        margin-top:140px;
        margin-bottom:8px;
        }

        p{
            font-size:14px;
            padding-bottom:16px;
        }

        .one {
            width:60px;
            height:60px;
        }

        .two {
            width:70px;
            height:70px;
        }

        .three {
            width:60px;
            height:60px;
        }

    }
</style>
